import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "/estimate/img/heading_3promise.png",
  alt: "昭和メタル３つのお約束",
  class: "full-width"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const data = [
  {
    heading: '営業や勧誘等のご連絡は一切いたしません。',
    description: null,
    annotation: '※査定のお申し込み後、電話でのご連絡はさせていただきますのでご了承ください。',
  },
  {
    heading: 'どんな車や状態でも必ず買取値を付けます。',
    description: null,
    annotation: '※ただし、回収困難な場所では手数料が発生することがございます。',
  },
  {
    heading: 'コンプライアンスを遵守いたします。',
    description: '自動車リサイクル法や個人情報保護法などの遵守を徹底しています。',
    annotation: null,
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.root)
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.$style.heading)
    }, _hoisted_2, 2),
    _createElementVNode("ol", {
      class: _normalizeClass(_ctx.$style.list)
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(data, ({ heading, description, annotation }, i) => {
        return _createElementVNode("li", {
          class: _normalizeClass(_ctx.$style.item),
          key: `promise_${heading}`
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.number)
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.$style.numberImage)
            }, [
              _createElementVNode("img", {
                src: `/estimate/img/3promise_icon0${i + 1}.png`,
                alt: ""
              }, null, 8, _hoisted_3)
            ], 2),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.$style.iconImage)
            }, [
              _createElementVNode("img", {
                src: `/estimate/img/3promise_icon0${i + 1}-2.png`
              }, null, 8, _hoisted_4)
            ], 2)
          ], 2),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.$style.text)
          }, _toDisplayString(heading), 3),
          description
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: _normalizeClass(_ctx.$style.description)
              }, _toDisplayString(description), 3))
            : _createCommentVNode("", true),
          annotation
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(_ctx.$style.annotation)
              }, _toDisplayString(annotation), 3))
            : _createCommentVNode("", true)
        ], 2)
      }), 64))
    ], 2)
  ], 2))
}
}

})